/**
 * Native Quantity Offers v5 → Releasit COD Form: sync free shipping per offer
 *
 * Replaces Releasit Bundle for free-shipping toggles only.
 * Gates on .section-quantity-offers-v5 — does not run when Releasit Bundle widget is present.
 */
(function () {
  'use strict';

  if (window.__rsiQoFreeShippingBridge) return;
  window.__rsiQoFreeShippingBridge = true;

  var STORAGE_KEY = 'rsi_qo_free_shipping';
  var FORM_SEL = '#_rsi-cod-form-modal-form';
  var FREE_RE = /gratis|free|sin\s*costo|sin\s*cargo/i;

  var state = {
    lastWanted: null,
    applying: false,
    formObserver: null,
    pollTimer: null,
    summaryTimer: null,
    offerApplyTimer: null,
    deferredApplyTimer: null,
    userPickedPaid: true, // default: Envío Flash / express
    userPickedFree: false,
    userChoseShipping: false, // true solo tras tap manual en método de envío
    lastOfferKey: null,
    userInteractionLockUntil: 0,
    programmaticSelect: false,
    lastIntentAt: 0,
    lastIntentKey: '',
    enforceWindowStart: 0,
    enforceCount: 0,
  };

  function isInteractionLocked() {
    return Date.now() < (state.userInteractionLockUntil || 0);
  }

  function lockUserInteraction(ms) {
    state.userInteractionLockUntil = Date.now() + (ms || 450);
  }

  function scheduleDeferredApply() {
    clearTimeout(state.deferredApplyTimer);
    var wait = Math.max(60, (state.userInteractionLockUntil || 0) - Date.now() + 80);
    state.deferredApplyTimer = setTimeout(function () {
      if (!isFormOpen()) return;
      applyToForm();
    }, wait);
  }

  function shouldSkipDuplicateIntent(e, key) {
    var now = Date.now();
    // pointerdown + click (o touchstart) del mismo gesto
    if (state.lastIntentKey === key && now - state.lastIntentAt < 650) return true;
    state.lastIntentKey = key;
    state.lastIntentAt = now;
    return false;
  }

  function readStoredFlag() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (v === '1') return true;
      if (v === '0') return false;
    } catch (e) { /* ignore */ }
    return false;
  }

  function writeStoredFlag(val) {
    try {
      localStorage.setItem(STORAGE_KEY, val ? '1' : '0');
    } catch (e) { /* ignore */ }
  }

  function hasBundleContext() {
    // Only treat Bundle as active when its widget is actually on the page.
    // Releasit may expose window.ReleasitBundles.freeShipping globally even
    // without a Bundle block — that must NOT disable Quantity Offers sync.
    return !!document.querySelector('.rb-widget, .rb-bundle-block, .rb-tier-item');
  }

  function hasQoContext() {
    return !!document.querySelector('.section-quantity-offers-v5 [data-free-shipping], [data-qov-version="v5"] [data-free-shipping]');
  }

  function getQoRoot() {
    return (
      document.querySelector('[data-qov-version="v5"]') ||
      document.querySelector('.section-quantity-offers-v5')
    );
  }

  function getFreeShippingForOfferIndex(index) {
    var root = getQoRoot();
    if (!root || index == null || index === '') return false;
    var card = root.querySelector('.qov4__card[data-offer-index="' + String(index) + '"]');
    if (card) return card.getAttribute('data-free-shipping') === 'true';
    return false;
  }

  function getSelectedPdpCard() {
    var root = getQoRoot();
    if (!root) return null;
    return root.querySelector('.qov4__card--selected');
  }

  function pdpSelectedOfferIndex() {
    var card = getSelectedPdpCard();
    if (!card) return null;
    return card.getAttribute('data-offer-index');
  }

  function detectFromReleasitModalOffer() {
    if (!isFormOpen()) return null;

    var hook = document.querySelector('#rsi-cod-form-quantity-offers-hook');
    if (!hook) return null;

    var selected = hook.querySelector('._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected');
    if (!selected) return null;

    var pos = selected.getAttribute('data-offer-pos');
    if (pos == null) {
      var all = hook.querySelectorAll('._rsi-quantity-offers-offer-container');
      for (var i = 0; i < all.length; i++) {
        if (all[i] === selected) {
          pos = String(i);
          break;
        }
      }
    }

    if (pos == null) return null;

    var pdpIndex = pdpSelectedOfferIndex();
    if (
      !window.__rsiQoModalOfferOverride &&
      pdpIndex != null &&
      String(pos) !== String(pdpIndex)
    ) {
      return null;
    }

    return getFreeShippingForOfferIndex(pos);
  }

  function detectFromPdpCard() {
    var card = getSelectedPdpCard();
    if (!card) return null;
    return card.getAttribute('data-free-shipping') === 'true';
  }

  function readSelectionStorageFlag() {
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf('qty_offer_v5_selection_') !== 0) continue;
        var raw = localStorage.getItem(key);
        if (!raw) continue;
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed.freeShipping === 'boolean') return parsed.freeShipping;
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function hasReleasitQuantityOffers() {
    return !!document.querySelector(
      '#rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers, #_rsi-cod-form-modal-form ._rsi-quantity-offers, ._rsi-quantity-offers-offer-container'
    );
  }

  function getRateTitleText(item) {
    if (!item) return '';
    var titleEl = item.querySelector('._rsi-modal-shipping-rates-item-title');
    if (!titleEl) return '';
    // El desc vive dentro del title; tomar solo el texto propio
    var clone = titleEl.cloneNode(true);
    var desc = clone.querySelector('._rsi-modal-shipping-rates-item-desc');
    if (desc && desc.parentNode) desc.parentNode.removeChild(desc);
    var svgs = clone.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) {
      if (svgs[i].parentNode) svgs[i].parentNode.removeChild(svgs[i]);
    }
    return normalizePriceText(clone.textContent);
  }

  function isFlashTitle(text) {
    return /flash/i.test(String(text || ''));
  }

  function isGratisTitle(text) {
    var t = String(text || '');
    return FREE_RE.test(t) || /env[ií]o\s*gratis/i.test(t);
  }

  /**
   * UI del form: gratis SOLO si el método seleccionado es Envío gratis.
   * Flash preseleccionado (default) nunca cuenta como gratis aunque el resumen diga "Gratis".
   */
  function detectFreeShippingFromFormUi() {
    var form = getForm();
    if (!form || !isFormOpen()) return null;

    var selected = form.querySelector('._rsi-modal-shipping-rates-item[data-selected="true"]');
    if (!selected) return null;

    var title = getRateTitleText(selected);
    if (isFlashTitle(title)) return false;

    var prio = selected.getAttribute('data-priority');
    var settingsRate = getSettingsRateByPriority(prio);
    var settingsPrice = settingsRate ? Number(settingsRate.price) : NaN;

    if (isGratisTitle(title) && !isFlashTitle(title)) return true;
    if (isFinite(settingsPrice) && settingsPrice === 0 && !isFlashTitle(title)) return true;
    if (isActuallyFreeRate(selected) && !isFlashTitle(title)) return true;
    return false;
  }

  function wantsFreeShipping() {
    if (hasBundleContext()) return false;

    // Default de tienda: express. Solo gratis si el usuario eligió Envío gratis
    // o el DOM ya tiene la tarifa gratis seleccionada.
    if (isFormOpen()) {
      var fromUi = detectFreeShippingFromFormUi();
      if (fromUi === true) {
        writeStoredFlag(true);
        return true;
      }
      if (fromUi === false) {
        writeStoredFlag(false);
        return false;
      }
    }

    // Ya no auto-forzamos gratis por flag de oferta QO — express es el default.
    return false;
  }

  function isFreeRateSelected(form) {
    if (!form) return false;
    var selected = form.querySelector('._rsi-modal-shipping-rates-item[data-selected="true"]');
    if (!selected) return false;
    var title = getRateTitleText(selected);
    if (isFlashTitle(title)) return false;
    if (isGratisTitle(title)) return true;
    return isActuallyFreeRate(selected);
  }

  /** Gratis en create-order solo si el cliente tiene Envío gratis seleccionado */
  function shouldEnforceFreeShipping(form) {
    if (hasBundleContext()) return false;
    if (state.userPickedPaid && !state.userPickedFree) return false;
    return isFreeRateSelected(form);
  }

  function getForm() {
    return document.querySelector(FORM_SEL);
  }

  function isFormOpen() {
    var modal = document.querySelector('#_rsi-cod-form-modal');
    return !!(modal && modal.classList.contains('_rsi-cod-form-modal-open') && getForm());
  }

  function normalizePriceText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function isFreePriceText(text) {
    var t = normalizePriceText(text);
    if (!t) return false;
    if (FREE_RE.test(t)) return true;
    var digits = t.replace(/[^\d]/g, '');
    return digits === '' || /^0+$/.test(digits);
  }

  function parseDisplayToNumber(text) {
    var t = normalizePriceText(text);
    if (!t || isFreePriceText(t)) return 0;
    if (!/\d/.test(t)) return 0;

    var negative = /^-/.test(t.replace(/\s/g, ''));
    // Descartar el símbolo de moneda antes del primer dígito: "S/." trae un punto
    // que se leía como decimal ("S/. 2" → 0.2 → total 0).
    t = t.slice(t.search(/\d/)).replace(/[^\d.,]/g, '').replace(/[.,]+$/, '');
    if (!t) return 0;

    var hasComma = t.indexOf(',') !== -1;
    var hasDot = t.indexOf('.') !== -1;
    if (hasComma && hasDot) {
      if (t.lastIndexOf(',') > t.lastIndexOf('.')) {
        t = t.replace(/\./g, '').replace(',', '.');
      } else {
        t = t.replace(/,/g, '');
      }
    } else if (hasComma && !hasDot) {
      var parts = t.split(',');
      if (parts[1] && parts[1].length === 3 && parts[0].length <= 3) {
        t = t.replace(',', '');
      } else {
        t = t.replace(',', '.');
      }
    } else if (hasDot && !hasComma) {
      var dparts = t.split('.');
      if (dparts.length === 2 && dparts[1].length === 3 && dparts[0].length <= 3) {
        t = t.replace(/\./g, '');
      }
    }

    var n = parseFloat(t);
    if (!isFinite(n)) return 0;
    return negative ? -n : n;
  }

  /**
   * Formatea igual que el texto de muestra (ej. subtotal de Releasit):
   * mismo símbolo, separadores y decimales. "S/. 129.90" → "S/. 99.90", "₡12.900" → "₡9.900".
   */
  function formatMoney(sampleText, value) {
    var n = Math.max(0, Number(value) || 0);
    var sample = normalizePriceText(sampleText);
    var m = sample.match(/\d(?:[\d.,]*\d)?/);
    if (!m) {
      try {
        return Math.round(n).toLocaleString('es-CO');
      } catch (e) {
        return String(Math.round(n));
      }
    }

    var num = m[0];
    var dec = '';
    var thou = '';
    var lastDot = num.lastIndexOf('.');
    var lastComma = num.lastIndexOf(',');
    if (lastDot !== -1 && lastComma !== -1) {
      dec = lastDot > lastComma ? '.' : ',';
    } else if (lastDot !== -1 || lastComma !== -1) {
      // Misma regla que parseDisplayToNumber: 1 separador + 3 dígitos = miles
      var sep = lastDot !== -1 ? '.' : ',';
      var parts = num.split(sep);
      if (parts.length === 2 && !(parts[1].length === 3 && parts[0].length <= 3)) dec = sep;
      else thou = sep;
    }
    var decimals = dec ? num.length - num.lastIndexOf(dec) - 1 : 0;
    if (!thou) thou = dec === ',' ? '.' : ',';
    if (!dec) dec = thou === '.' ? ',' : '.';
    if (!decimals && Math.round(n * 100) % 100 !== 0) decimals = 2;

    var fixed = n.toFixed(decimals).split('.');
    var intPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return (
      sample.slice(0, m.index) +
      intPart +
      (decimals ? dec + fixed[1] : '') +
      sample.slice(m.index + num.length)
    );
  }

  function getTotalLine(form) {
    return form.querySelector('[data-checkout-line="total"]');
  }

  function getTotalValueEl(form) {
    var totalLine = getTotalLine(form);
    if (!totalLine) return null;
    return (
      totalLine.querySelector('._rsi-modal-checkout-line-value:not(._rsi-modal-checkout-line-title)') ||
      totalLine.querySelector('span._rsi-modal-checkout-line-value')
    );
  }

  function getTotalTitleEl(form) {
    var totalLine = getTotalLine(form);
    return totalLine ? totalLine.querySelector('._rsi-modal-checkout-line-title') : null;
  }

  function ensureTotalLabel(form) {
    var title = getTotalTitleEl(form);
    if (title && !/^\s*total\s*$/i.test(normalizePriceText(title.textContent))) {
      title.textContent = 'Total';
    }
    var summaryLabel = form.querySelector('._rsi-order-summary-total-label');
    if (summaryLabel && !/^\s*total\s*$/i.test(normalizePriceText(summaryLabel.textContent))) {
      summaryLabel.textContent = 'Total';
    }
  }

  function getShippingRateItems(form) {
    return Array.prototype.slice.call(form.querySelectorAll('._rsi-modal-shipping-rates-item'));
  }

  function getRatePriceEl(item) {
    return item
      ? item.querySelector(
          '._rsi-shipping-price-wrapper ._rsi-modal-checkout-line-price, ._rsi-modal-checkout-line-price, ._rsi-modal-shipping-rates-item-price'
        )
      : null;
  }

  function getSettingsRateByPriority(priority) {
    if (priority == null) return null;
    var rates = getConfiguredShippingRates();
    for (var i = 0; i < rates.length; i++) {
      var r = rates[i];
      if (r && r.priority != null && String(r.priority) === String(priority)) return r;
    }
    return null;
  }

  function classifyRateIsFree(item) {
    if (!item) return false;
    var title = getRateTitleText(item);
    if (isFlashTitle(title)) return false;
    var prio = item.getAttribute('data-priority');
    var freePrio = getFreeRatePriorityFromSettings();
    var paidPrio = getPaidRatePriorityFromSettings();
    if (prio != null && String(prio) === String(freePrio)) return true;
    if (prio != null && String(prio) === String(paidPrio)) return false;
    var settingsRate = getSettingsRateByPriority(prio);
    if (settingsRate) {
      var price = Number(settingsRate.price);
      if (isFinite(price) && price > 0) return false;
      if (isFinite(price) && price === 0) {
        // Preferir custom "Envío gratis"; Default rate también es 0 pero no es la UI
        return true;
      }
    }
    if (isGratisTitle(title)) return true;
    var orig = item.getAttribute('data-rsi-orig-price') || (getRatePriceEl(item) && getRatePriceEl(item).textContent) || '';
    return isFreePriceText(orig);
  }

  function rememberOriginalRatePrice(item) {
    if (!item) return '';
    var el = getRatePriceEl(item);
    var current = el ? el.textContent : '';
    var prio = item.getAttribute('data-priority');
    var settingsRate = getSettingsRateByPriority(prio);

    // Clasificar SIEMPRE por priority/settings (nunca confiar solo en texto "Gratis" mutado)
    if (prio != null || item.getAttribute('data-rsi-is-free') == null) {
      var isFreeFlag = classifyRateIsFree(item) ? '1' : '0';
      // Escribir solo si cambia (antes cientos de escrituras/seg con el mismo valor)
      if (item.getAttribute('data-rsi-is-free') !== isFreeFlag) item.setAttribute('data-rsi-is-free', isFreeFlag);
    }

    if (item.getAttribute('data-rsi-orig-price') == null) {
      // Si es tarifa paga pero el DOM ya dice "Gratis", no guardar eso como original
      if (item.getAttribute('data-rsi-is-free') === '0' && isFreePriceText(current)) {
        if (settingsRate && isFinite(Number(settingsRate.price)) && Number(settingsRate.price) > 0) {
          // Dejar pendiente: applyPaidShipping / restore lo completará con sample del breakdown
          item.setAttribute('data-rsi-orig-price-pending', String(settingsRate.price));
        }
      } else if (current) {
        item.setAttribute('data-rsi-orig-price', current);
      }
    }
    return item.getAttribute('data-rsi-orig-price') || current || '';
  }

  function getRatePriceText(item) {
    rememberOriginalRatePrice(item);
    var el = getRatePriceEl(item);
    return el ? el.textContent : '';
  }

  function getRateOriginalPriceText(item) {
    rememberOriginalRatePrice(item);
    if (!item) return '';
    var stored = item.getAttribute('data-rsi-orig-price');
    if (stored) return stored;
    var pending = item.getAttribute('data-rsi-orig-price-pending');
    if (pending) {
      var sample =
        (document.querySelector('[data-checkout-line="subtotal"] ._rsi-modal-checkout-line-value') || {}).textContent ||
        '1.000';
      return formatMoney(sample, Number(pending));
    }
    return getRatePriceText(item);
  }

  function isActuallyFreeRate(item) {
    if (!item) return false;
    rememberOriginalRatePrice(item);
    if (item.getAttribute('data-rsi-is-free') === '1') return true;
    if (item.getAttribute('data-rsi-is-free') === '0') return false;
    return classifyRateIsFree(item);
  }

  function findFreeRate(form) {
    var items = getShippingRateItems(form);
    var freePrio = getFreeRatePriorityFromSettings();
    var i;
    var title;

    // 1) Priority exacta de "Envío gratis" (ej. 2), NUNCA Default (0) si hay custom
    for (i = 0; i < items.length; i++) {
      rememberOriginalRatePrice(items[i]);
      if (items[i].getAttribute('data-priority') != null && String(items[i].getAttribute('data-priority')) === String(freePrio)) {
        items[i].setAttribute('data-rsi-is-free', '1');
        return items[i];
      }
    }
    // 2) Título Envío gratis / Gratis (no Flash)
    for (i = 0; i < items.length; i++) {
      title = getRateTitleText(items[i]);
      if (isGratisTitle(title) && !isFlashTitle(title)) {
        items[i].setAttribute('data-rsi-is-free', '1');
        return items[i];
      }
    }
    // 3) Fallback: price 0 en settings, evitando Flash
    for (i = 0; i < items.length; i++) {
      title = getRateTitleText(items[i]);
      if (isFlashTitle(title)) continue;
      if (isActuallyFreeRate(items[i])) return items[i];
    }
    return null;
  }

  function findPaidRate(form) {
    var items = getShippingRateItems(form);
    var paidPrio = getPaidRatePriorityFromSettings();
    var i;
    for (i = 0; i < items.length; i++) {
      rememberOriginalRatePrice(items[i]);
      // Sin tarifa paga en settings, paidPrio cae al fallback '1'. Si la tarifa
      // gratis tiene justo priority 1 (esta tienda) no se debe tomar como paga.
      if (items[i].getAttribute('data-rsi-is-free') === '1') continue;
      if (items[i].getAttribute('data-priority') != null && String(items[i].getAttribute('data-priority')) === String(paidPrio)) {
        items[i].setAttribute('data-rsi-is-free', '0');
        return items[i];
      }
    }
    for (i = 0; i < items.length; i++) {
      if (!isActuallyFreeRate(items[i])) return items[i];
    }
    return null;
  }

  function syncSelectedRateDom(form, selectedItem) {
    if (!form || !selectedItem) return;
    getShippingRateItems(form).forEach(function (el) {
      el.setAttribute('data-selected', el === selectedItem ? 'true' : 'false');
    });
  }

  function selectRate(item, force) {
    if (!item) return false;
    var already = item.getAttribute('data-selected') === 'true';
    // force=true en submit / sync de sistema — nunca bloquear envío gratis real
    if (!force && isInteractionLocked()) return false;
    if (already && !force) return false;

    var form = item.closest(FORM_SEL);
    state.programmaticSelect = true;
    try {
      if (!already) {
        item.click();
      }
      // Refuerzo: Releasit a veces deja priority/DOM desfasados tras un solo click
      if (force && form) {
        syncSelectedRateDom(form, item);
        var prio = item.getAttribute('data-priority');
        if (prio != null) setShippingRatePriority(form, prio);
      }
    } finally {
      setTimeout(function () {
        state.programmaticSelect = false;
      }, 50);
    }
    return true;
  }

  function setTextIfChanged(el, text) {
    if (!el) return;
    if (normalizePriceText(el.textContent) === normalizePriceText(text)) return;
    el.textContent = text;
  }

  function readBreakdown(form) {
    var subEl = form.querySelector('[data-checkout-line="subtotal"] ._rsi-modal-checkout-line-value');
    var discEl = form.querySelector('[data-checkout-line="discount"] ._rsi-modal-checkout-line-value');
    var shipEl = form.querySelector('[data-checkout-line="shipping"] ._rsi-modal-checkout-line-value');
    var totalEl = getTotalValueEl(form);

    return {
      subtotal: parseDisplayToNumber(subEl && subEl.textContent),
      discount: Math.abs(parseDisplayToNumber(discEl && discEl.textContent)),
      shipping: isFreePriceText(shipEl && shipEl.textContent)
        ? 0
        : parseDisplayToNumber(shipEl && shipEl.textContent),
      shippingText: shipEl ? shipEl.textContent : '',
      total: parseDisplayToNumber(totalEl && totalEl.textContent),
      sample: (subEl && subEl.textContent) || (totalEl && totalEl.textContent) || '1.000',
      totalEl: totalEl,
    };
  }

  function computePayable(breakdown, freeShipping) {
    var ship = freeShipping ? 0 : breakdown.shipping;
    if (breakdown.subtotal > 0) {
      return Math.max(0, breakdown.subtotal - breakdown.discount + ship);
    }
    if (freeShipping && breakdown.shipping > 0 && breakdown.total > 0) {
      return Math.max(0, breakdown.total - breakdown.shipping);
    }
    return Math.max(0, breakdown.total);
  }

  function payableToOrderAttr(form, payable) {
    var totalLine = getTotalLine(form);
    var raw = totalLine ? parseInt(totalLine.getAttribute('data-order-total'), 10) : NaN;
    var shown = parseDisplayToNumber(getTotalValueEl(form) && getTotalValueEl(form).textContent);
    var sub = parseDisplayToNumber(
      form.querySelector('[data-checkout-line="subtotal"] ._rsi-modal-checkout-line-value') &&
        form.querySelector('[data-checkout-line="subtotal"] ._rsi-modal-checkout-line-value').textContent
    );
    var ref = shown > 0 ? shown : sub;
    if (isFinite(raw) && raw > 0 && ref > 0) {
      if (Math.abs(raw / ref - 100) < 1 || raw >= ref * 50) return Math.round(payable * 100);
      if (Math.abs(raw - ref) < 2) return Math.round(payable);
    }
    return Math.round(payable * 100);
  }

  function syncPayableEverywhere(form, payable, sample) {
    ensureTotalLabel(form);
    var amountText = formatMoney(sample, payable);
    var orderAttr = payableToOrderAttr(form, payable);
    var totalLine = getTotalLine(form);

    setTextIfChanged(getTotalValueEl(form), amountText);
    setTextIfChanged(form.querySelector('.rsi-cod-form-submit-total-value'), amountText);
    setTextIfChanged(form.querySelector('._rsi-order-summary-total-amount'), amountText);

    if (totalLine) {
      totalLine.setAttribute('data-order-total', String(orderAttr));
      totalLine.setAttribute('data-partial-total-for-checkout', String(orderAttr));
    }
  }

  function restoreShippingRateLabels(form) {
    getShippingRateItems(form).forEach(function (item) {
      rememberOriginalRatePrice(item);
      var priceEl = getRatePriceEl(item);
      if (!priceEl) return;
      if (isActuallyFreeRate(item)) {
        setTextIfChanged(priceEl, 'Gratis');
      } else {
        var orig = getRateOriginalPriceText(item);
        if (orig && !isFreePriceText(orig)) {
          setTextIfChanged(priceEl, orig);
          if (!item.getAttribute('data-rsi-orig-price')) {
            item.setAttribute('data-rsi-orig-price', orig);
          }
        }
      }
    });
  }

  function markShippingGratis(form) {
    var shipLine = form.querySelector('[data-checkout-line="shipping"] ._rsi-modal-checkout-line-value');
    setTextIfChanged(shipLine, 'Gratis');

    var freeRate = findFreeRate(form);

    getShippingRateItems(form).forEach(function (item) {
      rememberOriginalRatePrice(item);
      var priceEl = getRatePriceEl(item);
      if (!priceEl) return;

      if (item === freeRate || isActuallyFreeRate(item)) {
        setTextIfChanged(priceEl, 'Gratis');
      } else {
        // NUNCA dejar "Gratis" pintado sobre una tarifa paga (bug que cobraba $10)
        var orig = getRateOriginalPriceText(item);
        if (orig && !isFreePriceText(orig)) {
          setTextIfChanged(priceEl, orig);
          if (!item.getAttribute('data-rsi-orig-price')) {
            item.setAttribute('data-rsi-orig-price', orig);
          }
        }
      }
    });

    form.querySelectorAll('._rsi-order-summary-item.parent').forEach(function (li) {
      var nameEl = li.querySelector('._rsi-order-summary-item-name');
      var priceEl = li.querySelector('._rsi-order-summary-item-price');
      if (!nameEl || !priceEl) return;
      if (/env[ií]o|shipping|flash/i.test(nameEl.textContent || '')) {
        // Solo marcar gratis el ítem de envío si la tarifa activa es realmente gratis
        if (freeRate && freeRate.getAttribute('data-selected') === 'true') {
          setTextIfChanged(priceEl, 'Gratis');
        }
      }
    });
  }

  function injectPropertyFlag(form, enabled) {
    form.querySelectorAll('input[name^="item_properties"]').forEach(function (input) {
      try {
        var decoded = decodeURIComponent(input.value || '');
        var props = JSON.parse(decoded);
        if (enabled) {
          props._free_shipping = 'true';
          props._quantity_offer_free_shipping = 'true';
        } else {
          delete props._free_shipping;
          delete props._quantity_offer_free_shipping;
        }
        input.value = encodeURIComponent(JSON.stringify(props));
      } catch (e) { /* ignore */ }
    });
  }

  function getCodFormSettings() {
    return (
      window._RSI_COD_FORM_SETTINGS ||
      (window._rsi && window._rsi.s) ||
      (window._rsiV2 && window._rsiV2.s) ||
      null
    );
  }

  function getConfiguredShippingRates() {
    var settings = getCodFormSettings();
    var rates =
      (settings && settings.shippingRates && settings.shippingRates.items_array) ||
      (settings && settings.shipping_rates && settings.shipping_rates.items_array) ||
      null;
    return Array.isArray(rates) ? rates : [];
  }

  function getFreeRatePriorityFromSettings() {
    var rates = getConfiguredShippingRates();
    var i;
    var r;
    var price;
    var title;

    // Tienda real:
    //   Default rate { price:0, priority:0, type:default }  ← NO usar si hay Envío gratis custom
    //   Envío Flash  { price:1000, priority:1 }
    //   Envío gratis { price:0, priority:2, type:custom } ← ESTE es el que ve el cliente
    for (i = 0; i < rates.length; i++) {
      r = rates[i];
      if (!r || r.type === 'default') continue;
      price = Number(r.price);
      title = String(r.title || '');
      if (isFinite(price) && price === 0 && (FREE_RE.test(title) || /env[ií]o\s*gratis/i.test(title))) {
        return r.priority != null ? String(r.priority) : '0';
      }
    }
    for (i = 0; i < rates.length; i++) {
      r = rates[i];
      if (!r || r.type === 'default') continue;
      price = Number(r.price);
      if (isFinite(price) && price === 0) {
        return r.priority != null ? String(r.priority) : '0';
      }
    }
    for (i = 0; i < rates.length; i++) {
      r = rates[i];
      if (!r) continue;
      price = Number(r.price);
      if (isFinite(price) && price === 0) {
        return r.priority != null ? String(r.priority) : '0';
      }
    }
    return '0';
  }

  function getPaidRatePriorityFromSettings() {
    var rates = getConfiguredShippingRates();
    for (var i = 0; i < rates.length; i++) {
      var r = rates[i];
      if (!r) continue;
      var price = Number(r.price);
      if (isFinite(price) && price > 0) {
        return r.priority != null ? String(r.priority) : '1';
      }
    }
    return '1';
  }

  /**
   * Priority autoritativa para create-order.
   * En tu form real: Envío gratis = 2, Flash = 1, Default = 0 (oculto).
   * Preferir el data-priority del item seleccionado si es gratis.
   */
  function getAuthoritativeFreePriority(form) {
    if (form) {
      var selected = form.querySelector('._rsi-modal-shipping-rates-item[data-selected="true"]');
      if (selected) {
        var title = getRateTitleText(selected);
        var prio = selected.getAttribute('data-priority');
        if (prio != null && (isGratisTitle(title) || isActuallyFreeRate(selected)) && !isFlashTitle(title)) {
          return String(prio);
        }
      }
      var freeRate = findFreeRate(form);
      if (freeRate && freeRate.getAttribute('data-priority') != null) {
        return String(freeRate.getAttribute('data-priority'));
      }
    }
    return getFreeRatePriorityFromSettings();
  }

  function syncRsiFormDataPriority(priority) {
    if (priority == null) return;
    try {
      if (!window._rsi) window._rsi = {};
      if (!Array.isArray(window._rsi.formData)) window._rsi.formData = [];

      var found = false;
      window._rsi.formData.forEach(function (entry) {
        if (!entry || entry.name !== 'shipping_rate_priority') return;
        entry.value = String(priority);
        found = true;
      });
      if (!found) {
        window._rsi.formData.push({ name: 'shipping_rate_priority', value: String(priority) });
      }

      // Algunos builds guardan settings en _rsi.s / form snapshot
      if (window._rsi.shipping_rate_priority != null) {
        window._rsi.shipping_rate_priority = String(priority);
      }
    } catch (e) { /* ignore */ }
  }

  function syncAllShippingPriorityInputs(form, priority) {
    if (!form || priority == null) return;
    var inputs = form.querySelectorAll('input[name="shipping_rate_priority"]');
    if (!inputs.length) {
      setShippingRatePriority(form, priority);
      inputs = form.querySelectorAll('input[name="shipping_rate_priority"]');
    }
    Array.prototype.forEach.call(inputs, function (input) {
      input.value = String(priority);
      input.setAttribute('data-rsi-qo-forced-priority', String(priority));
    });
    syncRsiFormDataPriority(priority);
  }

  function setShippingRatePriority(form, priority) {
    if (!form || priority == null) return;
    var input = form.querySelector('input[name="shipping_rate_priority"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'shipping_rate_priority';
      form.appendChild(input);
    }
    input.value = String(priority);
    input.setAttribute('data-rsi-qo-forced-priority', String(priority));
    syncRsiFormDataPriority(priority);
  }

  /**
   * CRÍTICO: Releasit lee data-priority del item seleccionado al create-order.
   * Pintar "Gratis" en Flash (priority 1) NO basta — hay que sellar priority gratis.
   */
  function stampSelectedRatePriority(form, priority) {
    if (!form || priority == null) return;
    syncAllShippingPriorityInputs(form, priority);

    getShippingRateItems(form).forEach(function (item) {
      if (!item.hasAttribute('data-rsi-qo-orig-priority')) {
        item.setAttribute(
          'data-rsi-qo-orig-priority',
          item.getAttribute('data-priority') == null ? '' : item.getAttribute('data-priority')
        );
      }
    });

    var freeRate = findFreeRate(form);
    var selected = form.querySelector('._rsi-modal-shipping-rates-item[data-selected="true"]');

    // Si el seleccionado es Flash pero debemos forzar gratis, no mutar Flash→2:
    // seleccionar Envío gratis y sellar su priority real.
    if (freeRate) {
      if (!selected || selected !== freeRate) {
        syncSelectedRateDom(form, freeRate);
        selected = freeRate;
      }
      // Restaurar priority original del free rate si lo habíamos tocado
      var orig = freeRate.getAttribute('data-rsi-qo-orig-priority');
      if (orig) freeRate.setAttribute('data-priority', orig);
      else freeRate.setAttribute('data-priority', String(priority));
      freeRate.setAttribute('data-rsi-is-free', '1');
    } else if (selected) {
      selected.setAttribute('data-priority', String(priority));
      selected.setAttribute('data-rsi-is-free', '1');
    }

    syncAllShippingPriorityInputs(form, priority);
  }

  function restoreSelectedRatePriorities(form) {
    if (!form) return;
    form.querySelectorAll('._rsi-modal-shipping-rates-item[data-rsi-qo-orig-priority]').forEach(function (item) {
      var orig = item.getAttribute('data-rsi-qo-orig-priority');
      if (orig !== '') item.setAttribute('data-priority', orig);
      item.removeAttribute('data-rsi-qo-orig-priority');
    });
  }

  function ensureHiddenField(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = String(value);
    return input;
  }

  function removeHiddenField(form, name) {
    form.querySelectorAll('input[name="' + name + '"]').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function patchRsiFormDataProperties(free) {
    try {
      if (window._rsi && Array.isArray(window._rsi.formData)) {
        window._rsi.formData.forEach(function (entry) {
          if (!entry || !entry.name || String(entry.name).indexOf('item_properties') !== 0) return;
          try {
            var props = typeof entry.value === 'string' ? JSON.parse(entry.value) : entry.value;
            if (!props || typeof props !== 'object') return;
            if (free) {
              props._free_shipping = 'true';
              props._quantity_offer_free_shipping = 'true';
            } else {
              delete props._free_shipping;
              delete props._quantity_offer_free_shipping;
            }
            entry.value = typeof entry.value === 'string' ? JSON.stringify(props) : props;
          } catch (err) { /* ignore */ }
        });
      }
    } catch (e) { /* ignore */ }

    try {
      if (window._rsi && window._rsi.formData) {
        var prioEntry = window._rsi.formData.find(function (e) {
          return e && e.name === 'shipping_rate_priority';
        });
        if (prioEntry) {
          prioEntry.value = free
            ? getAuthoritativeFreePriority(getForm())
            : getPaidRatePriorityFromSettings();
        }
      }
    } catch (e2) { /* ignore */ }
  }

  function prepareOrderFreeShipping(form) {
    if (!form) return;
    injectPropertyFlag(form, true);
    patchRsiFormDataProperties(true);

    // Usar priority del DOM (Envío gratis = 2), NUNCA Default(0) ni Flash(1)
    var freePriority = getAuthoritativeFreePriority(form);

    var freeRate = findFreeRate(form);
    if (freeRate) {
      // Solo click si no está seleccionado — evitar race que pisa formData
      if (freeRate.getAttribute('data-selected') !== 'true') {
        selectRate(freeRate, true);
      }
      syncSelectedRateDom(form, freeRate);
    }

    stampSelectedRatePriority(form, freePriority);
    // Doble sello: create-order de Releasit lee _rsi.formData + hidden input
    syncAllShippingPriorityInputs(form, freePriority);

    markShippingGratis(form);

    var breakdown = readBreakdown(form);
    var payable = computePayable(breakdown, true);
    if (payable > 0) syncPayableEverywhere(form, payable, breakdown.sample);

    ensureHiddenField(form, 'shipping_price', '0');
    ensureHiddenField(form, 'shipping_cost', '0');
    ensureHiddenField(form, 'shipping_amount', '0');
  }

  /** Envío Flash / express (pago) — default de tienda + sync create-order */
  function prepareOrderPaidShipping(form) {
    if (!form) return;

    ['shipping_price', 'shipping_cost', 'shipping_amount', 'force_free_shipping', 'free_shipping'].forEach(
      function (name) {
        removeHiddenField(form, name);
      }
    );
    injectPropertyFlag(form, false);
    patchRsiFormDataProperties(false);
    restoreSelectedRatePriorities(form);

    var paidRate = findPaidRate(form);
    var paidPrio = getPaidRatePriorityFromSettings();

    if (paidRate) {
      if (paidRate.getAttribute('data-selected') !== 'true') {
        selectRate(paidRate, true);
      }
      syncSelectedRateDom(form, paidRate);
      var orig = paidRate.getAttribute('data-rsi-qo-orig-priority');
      if (orig) paidRate.setAttribute('data-priority', orig);
      else if (paidRate.getAttribute('data-priority') == null) {
        paidRate.setAttribute('data-priority', String(paidPrio));
      }
    }

    syncAllShippingPriorityInputs(form, paidPrio);
    restoreShippingRateLabels(form);
    applyPaidShipping(form);

    // Asegurar que la línea de envío NO diga Gratis con Flash seleccionado
    var shipLine = form.querySelector('[data-checkout-line="shipping"] ._rsi-modal-checkout-line-value');
    if (paidRate && shipLine) {
      var priceText = getRateOriginalPriceText(paidRate);
      if (priceText && !isFreePriceText(priceText)) {
        setTextIfChanged(shipLine, priceText);
      }
    }

    var breakdown = readBreakdown(form);
    var payable = computePayable(breakdown, false);
    if (payable > 0) syncPayableEverywhere(form, payable, breakdown.sample);
  }

  /** Default al abrir: preseleccionar Envío Flash (express) */
  function ensureExpressPreselected(form) {
    if (!form || hasBundleContext()) return;
    if (state.userChoseShipping && state.userPickedFree) return;
    prepareOrderPaidShipping(form);
    state.userPickedPaid = true;
    state.userPickedFree = false;
    state.lastWanted = false;
  }

  function clearOrderFreeShippingExtras(form) {
    if (!form) return;
    // Si el usuario eligió gratis a propósito, no pisar a Flash
    if (state.userPickedFree && isFreeRateSelected(form)) {
      prepareOrderFreeShipping(form);
      return;
    }
    prepareOrderPaidShipping(form);
  }

  function totalLooksBroken(breakdown, payable) {
    if (!(breakdown.total > 0)) return true;
    if (payable > 0 && Math.abs(breakdown.total - payable) > 1) return true;
    var submit = document.querySelector('.rsi-cod-form-submit-total-value');
    if (submit && isFreePriceText(submit.textContent)) return true;
    return false;
  }

  function applyFreeShipping(form) {
    markShippingGratis(form);
    var breakdown = readBreakdown(form);
    var payable = computePayable(breakdown, true);
    if (payable > 0) syncPayableEverywhere(form, payable, breakdown.sample);
    injectPropertyFlag(form, true);
  }

  function applyPaidShipping(form) {
    injectPropertyFlag(form, false);
    restoreShippingRateLabels(form);
    ensureTotalLabel(form);
    var breakdown = readBreakdown(form);
    var payable = computePayable(breakdown, false);
    if (payable > 0 && totalLooksBroken(breakdown, payable)) {
      syncPayableEverywhere(form, payable, breakdown.sample);
    }
  }

  function refreshOrderSummary() {
    clearTimeout(state.summaryTimer);
    state.summaryTimer = setTimeout(function () {
      try {
        if (typeof window._rsiUpdateOrderSummary === 'function') {
          window._rsiUpdateOrderSummary();
        }
      } catch (e) { /* ignore */ }
    }, 120);
  }

  function isShippingKey(key) {
    var k = String(key || '').toLowerCase();
    if (!k) return false;
    if (
      k === 'shipping' ||
      k === 'shipping_price' ||
      k === 'shipping_cost' ||
      k === 'shipping_amount' ||
      k === 'shipping_fee' ||
      k === 'shippingprice' ||
      k === 'shippingcost' ||
      k === 'shippingamount' ||
      k === 'shipping_rate_price' ||
      k === 'rate_price' ||
      k === 'delivery_price' ||
      k === 'delivery_cost'
    ) {
      return true;
    }
    return /shipping/.test(k) && /(price|cost|amount|fee|value)/.test(k);
  }

  function zeroShippingInObject(obj, depth) {
    if (!obj || typeof obj !== 'object' || depth > 8) return;
    var freePriority = getAuthoritativeFreePriority(getForm());
    if (Array.isArray(obj)) {
      obj.forEach(function (item) {
        zeroShippingInObject(item, depth + 1);
      });
      return;
    }
    Object.keys(obj).forEach(function (key) {
      var val = obj[key];
      var lk = key.toLowerCase();
      if (lk === 'shipping_rate_priority' || lk === 'shippingratepriority') {
        obj[key] = freePriority;
        return;
      }
      if (isShippingKey(key) && (typeof val === 'number' || typeof val === 'string')) {
        obj[key] = typeof val === 'number' ? 0 : '0';
        return;
      }
      if (lk === 'shipping' && val && typeof val === 'object') {
        ['price', 'cost', 'amount', 'fee', 'value', 'priority'].forEach(function (sub) {
          if (val[sub] == null) return;
          if (sub === 'priority') val[sub] = freePriority;
          else val[sub] = typeof val[sub] === 'number' ? 0 : '0';
        });
      }
      if (val && typeof val === 'object') zeroShippingInObject(val, depth + 1);
    });
  }

  function patchOutgoingBody(body) {
    var form = getForm();
    var wantFree = isFreeRateSelected(form);
    var priority = wantFree
      ? getAuthoritativeFreePriority(form)
      : getPaidRatePriorityFromSettings();

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      try {
        body.set('shipping_rate_priority', priority);
      } catch (e) {
        try {
          body.append('shipping_rate_priority', priority);
        } catch (e2) { /* ignore */ }
      }
      if (wantFree) {
        ['shipping_price', 'shipping_cost', 'shipping_amount'].forEach(function (name) {
          try {
            body.set(name, '0');
          } catch (e3) {
            try {
              body.append(name, '0');
            } catch (e4) { /* ignore */ }
          }
        });
      }
      return body;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.set('shipping_rate_priority', priority);
      if (wantFree) {
        body.set('shipping_price', '0');
        body.set('shipping_cost', '0');
      }
      return body;
    }

    if (typeof body === 'string' && body) {
      try {
        var parsed = JSON.parse(body);
        if (parsed && typeof parsed === 'object') {
          if (wantFree) zeroShippingInObject(parsed, 0);
          else parsed.shipping_rate_priority = priority;
          return JSON.stringify(parsed);
        }
      } catch (e) {
        var out = body;
        if (/shipping_rate_priority=/.test(out)) {
          out = out.replace(
            /shipping_rate_priority=[^&]*/i,
            'shipping_rate_priority=' + encodeURIComponent(priority)
          );
        } else if (out.indexOf('=') !== -1) {
          out += (out ? '&' : '') + 'shipping_rate_priority=' + encodeURIComponent(priority);
        }
        if (wantFree) {
          out = out.replace(/(shipping[_-]?(?:price|cost|amount|fee))=([^&]*)/gi, '$1=0');
        }
        return out;
      }
    }

    if (body && typeof body === 'object') {
      try {
        if (wantFree) zeroShippingInObject(body, 0);
        else if (body.shipping_rate_priority != null) body.shipping_rate_priority = priority;
      } catch (e5) { /* ignore */ }
    }

    return body;
  }

  function looksLikeOrderCreate(url, body) {
    var u = String(url || '').toLowerCase();
    if (/rsi-cod-form|create-order|releas|cod-?form|codform|get-?form|abandoned/.test(u)) return true;
    if (typeof body === 'string' && /shipping_rate_priority|item_variant_id|item_properties/.test(body)) {
      return true;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return body.has('shipping_rate_priority') || body.has('item_variant_id[0]') || body.has('phone');
    }
    if (body && typeof body === 'object') {
      return (
        body.shipping_rate_priority != null ||
        body.item_variant_id != null ||
        body.phone != null
      );
    }
    return false;
  }

  function installNetworkHooks() {
    if (window.__rsiQoFreeShipNetHooked) return;
    window.__rsiQoFreeShipNetHooked = true;

    if (window.fetch) {
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          init = init || {};
          var body = init.body;
          var form = getForm();
          if (looksLikeOrderCreate(url, body) && form) {
            if (isFreeRateSelected(form)) prepareOrderFreeShipping(form);
            else prepareOrderPaidShipping(form);
            if (body != null) {
              init = Object.assign({}, init, { body: patchOutgoingBody(body) });
            }
          }
        } catch (e) { /* ignore */ }
        return nativeFetch(input, init);
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var nativeOpen = window.XMLHttpRequest.prototype.open;
      var nativeSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__rsiUrl = url;
        return nativeOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function (body) {
        try {
          var form = getForm();
          if (looksLikeOrderCreate(this.__rsiUrl, body) && form) {
            if (isFreeRateSelected(form)) prepareOrderFreeShipping(form);
            else prepareOrderPaidShipping(form);
            body = patchOutgoingBody(body);
          }
        } catch (e) { /* ignore */ }
        return nativeSend.call(this, body);
      };
    }
  }

  function installSubmitHooks() {
    if (window.__rsiQoFreeShipSubmitHooked) return;
    window.__rsiQoFreeShipSubmitHooked = true;

    function ensureShippingOnSubmit(form) {
      if (!form) return;
      if (isFreeRateSelected(form)) {
        state.userPickedFree = true;
        state.userPickedPaid = false;
        prepareOrderFreeShipping(form);
        syncAllShippingPriorityInputs(form, getAuthoritativeFreePriority(form));
      } else {
        state.userPickedPaid = true;
        state.userPickedFree = false;
        prepareOrderPaidShipping(form);
        syncAllShippingPriorityInputs(form, getPaidRatePriorityFromSettings());
      }
    }

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.id !== '_rsi-cod-form-modal-form') return;
        ensureShippingOnSubmit(form);
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var btn = e.target.closest(
          '#_rsi-cod-form-modal-form ._rsi-modal-submit-button, #_rsi-cod-form-modal-form button[type="submit"]'
        );
        if (!btn) return;
        var form = getForm();
        if (!form) return;
        ensureShippingOnSubmit(form);
      },
      true
    );
  }

  /** Tarifa que DEBE estar seleccionada: la que eligió el cliente, o Flash por defecto */
  function getDesiredRate(form) {
    return state.userPickedFree ? findFreeRate(form) : findPaidRate(form);
  }

  /**
   * Corrige en el mismo instante de la mutación (microtask, antes de pintar) cuando
   * Releasit re-pinta las tarifas con otra seleccionada. Así nunca se ve el salto.
   */
  function enforceDesiredRateNow() {
    var form = getForm();
    if (!form || !isFormOpen() || hasBundleContext()) return false;
    // Durante un tap del cliente en el método de envío, no pelear con su elección
    if (state.applying || isInteractionLocked()) return false;
    var desired = getDesiredRate(form);
    if (!desired || desired.getAttribute('data-selected') === 'true') return false;
    // Anti-loop: si Releasit insistiera, el ciclo normal (scheduleApply) lo resuelve
    var now = Date.now();
    if (now - state.enforceWindowStart > 1000) {
      state.enforceWindowStart = now;
      state.enforceCount = 0;
    }
    if (++state.enforceCount > 6) return false;
    applyToForm();
    return true;
  }

  function applyToForm() {
    var form = getForm();
    if (!form || !isFormOpen()) return;
    if (state.applying) return;
    if (hasBundleContext()) return;

    state.applying = true;

    function finish() {
      state.applying = false;
    }

    try {
      getShippingRateItems(form).forEach(rememberOriginalRatePrice);

      // Default de tienda: Envío Flash preseleccionado hasta que el usuario elija
      if (!state.userChoseShipping) {
        if (isInteractionLocked()) {
          scheduleDeferredApply();
          finish();
          return;
        }
        ensureExpressPreselected(form);
        refreshOrderSummary();
        finish();
        return;
      }

      // La elección del cliente manda (no el DOM: Releasit lo re-pinta al cambiar oferta)
      if (state.userPickedFree) {
        prepareOrderFreeShipping(form);
        state.lastWanted = true;
        refreshOrderSummary();
      } else {
        prepareOrderPaidShipping(form);
        state.lastWanted = false;
        refreshOrderSummary();
      }
    } catch (e) {
      finish();
      return;
    }

    finish();
  }

  function scheduleApply() {
    clearTimeout(state.pollTimer);
    state.pollTimer = setTimeout(applyToForm, isInteractionLocked() ? 280 : 120);
  }

  function watchForm() {
    var form = getForm();
    if (!form) return;
    if (state.formObserver) {
      state.formObserver.disconnect();
      state.formObserver = null;
    }

    state.formObserver = new MutationObserver(function () {
      if (state.applying || isInteractionLocked()) return;
      if (enforceDesiredRateNow()) return;
      // Solo corregir si el usuario ya eligió un método; el default express lo maneja applyToForm
      if (!state.userChoseShipping) {
        scheduleApply();
        return;
      }
      if (state.userPickedFree && isFreeRateSelected(form)) {
        var breakdown = readBreakdown(form);
        var payable = computePayable(breakdown, true);
        var prio = form.querySelector('input[name="shipping_rate_priority"]');
        var freePrio = getAuthoritativeFreePriority(form);
        var needsFix =
          !isFreePriceText(breakdown.shippingText) ||
          (prio && String(prio.value) !== String(freePrio)) ||
          (payable > 0 && Math.abs(breakdown.total - payable) > 1);
        if (needsFix) scheduleApply();
      }
    });

    state.formObserver.observe(form, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-order-total', 'data-partial-total-for-checkout', 'data-selected'],
    });
  }

  function onQoFlagMaybeChanged() {
    writeStoredFlag(wantsFreeShipping());
    if (isFormOpen()) scheduleApply();
  }

  function handleOfferIntent(e) {
    if (state.programmaticSelect) return;
    if (!e.target || !e.target.closest) return;

    var pdpCard = e.target.closest('.section-quantity-offers-v5 .qov4__card, [data-qov-version="v5"] .qov4__card');
    var modalOffer = e.target.closest(
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container, #rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers-offer-container'
    );
    if (!pdpCard && !modalOffer) return;

    var key = pdpCard ? 'pdp-offer' : 'modal-offer:' + (modalOffer.getAttribute('data-offer-pos') || '');
    if (shouldSkipDuplicateIntent(e, key)) return;

    // Cambiar de oferta NO toca el método de envío: se conserva el que ya estaba
    // (Flash por defecto o el que eligió el cliente). Tampoco se bloquea: Releasit
    // re-pinta las tarifas con "Envío gratis" al cambiar la oferta y eso se corrige
    // en el acto (enforceDesiredRateNow), no 300-700ms después (era el rebote).
    if (modalOffer) window.__rsiQoModalOfferOverride = true;

    clearTimeout(state.offerApplyTimer);
    state.offerApplyTimer = setTimeout(function () {
      if (isFormOpen()) scheduleApply();
    }, 300);
  }

  function handleShippingIntent(e) {
    if (state.programmaticSelect) return;
    if (!e.target || !e.target.closest) return;
    var shippingItem = e.target.closest('._rsi-modal-shipping-rates-item');
    if (!shippingItem || !isFormOpen() || hasBundleContext()) return;

    var key = 'ship:' + (shippingItem.getAttribute('data-priority') || shippingItem.textContent || '').slice(0, 40);
    if (shouldSkipDuplicateIntent(e, key)) return;

    rememberOriginalRatePrice(shippingItem);
    lockUserInteraction(280);

    var title = getRateTitleText(shippingItem);
    var pickingPaid =
      isFlashTitle(title) ||
      (!isActuallyFreeRate(shippingItem) && !isGratisTitle(title));

    state.userChoseShipping = true;

    if (pickingPaid) {
      state.userPickedPaid = true;
      state.userPickedFree = false;
      clearTimeout(state.pollTimer);
      state.pollTimer = setTimeout(function () {
        var form = getForm();
        if (!form) return;
        prepareOrderPaidShipping(form);
        refreshOrderSummary();
      }, 180);
    } else {
      state.userPickedPaid = false;
      state.userPickedFree = true;
      clearTimeout(state.pollTimer);
      state.pollTimer = setTimeout(function () {
        var form = getForm();
        if (!form) return;
        prepareOrderFreeShipping(form);
        refreshOrderSummary();
      }, 180);
    }
  }

  function hookModalBus() {
    if (!window._rsiModalBus || window._rsiModalBus.__qoFreeShipHooked) return;
    window._rsiModalBus.__qoFreeShipHooked = true;

    var originalOpen = window._rsiModalBus.open.bind(window._rsiModalBus);
    window._rsiModalBus.open = function () {
      if (window.__qov5Instances && window.__qov5Instances.length) {
        window.__qov5Instances.forEach(function (inst) {
          if (inst && typeof inst.syncFromPdpImmediate === 'function') {
            inst.syncFromPdpImmediate();
          }
        });
      }

      originalOpen();
      // Default: Envío Flash / express preseleccionado
      state.userChoseShipping = false;
      state.userPickedPaid = true;
      state.userPickedFree = false;
      state.userInteractionLockUntil = 0;
      try {
        var formOnOpen = getForm();
        if (formOnOpen) {
          getShippingRateItems(formOnOpen).forEach(function (item) {
            item.removeAttribute('data-rsi-orig-price');
            item.removeAttribute('data-rsi-orig-price-pending');
            item.removeAttribute('data-rsi-is-free');
          });
        }
      } catch (e) { /* ignore */ }
      watchForm();
      // Flash preseleccionado desde el primer frame (antes se veía Gratis ~200ms)
      applyToForm();
      setTimeout(function () {
        ensureExpressPreselected(getForm());
        applyToForm();
      }, 200);
      setTimeout(function () {
        ensureExpressPreselected(getForm());
        applyToForm();
      }, 500);
      setTimeout(function () {
        ensureExpressPreselected(getForm());
        applyToForm();
      }, 1000);

      if (window.__qov5Instances && window.__qov5Instances.length) {
        window.__qov5Instances.forEach(function (inst) {
          if (inst && typeof inst.syncFromPdpIfSelected === 'function') {
            setTimeout(function () {
              inst.syncWithReleasit();
            }, 400);
          }
        });
      }
    };

    var originalClose = window._rsiModalBus.close.bind(window._rsiModalBus);
    window._rsiModalBus.close = function () {
      originalClose();
      state.lastWanted = null;
      state.userChoseShipping = false;
      state.userPickedPaid = true;
      state.userPickedFree = false;
      state.lastOfferKey = null;
      state.userInteractionLockUntil = 0;
      window.__rsiQoModalOfferOverride = false;
      if (state.formObserver) {
        state.formObserver.disconnect();
        state.formObserver = null;
      }
    };
  }

  // Un solo camino primario: pointerdown (iOS). click solo fallback.
  document.addEventListener('pointerdown', handleOfferIntent, true);
  document.addEventListener('pointerdown', handleShippingIntent, true);
  document.addEventListener(
    'click',
    function (e) {
      if (state.programmaticSelect) return;
      if (Date.now() - state.lastIntentAt < 650) return;
      handleOfferIntent(e);
      handleShippingIntent(e);
    },
    true
  );

  document.addEventListener('rsi-qo-free-shipping-change', function () {
    // Oferta QO cambió: mantener default express (no auto-gratis)
    if (isFormOpen() && !state.userChoseShipping) scheduleApply();
  });

  setInterval(function () {
    if (hasBundleContext()) return;
    if (isInteractionLocked() || state.applying) return;
    if (!isFormOpen()) return;
    // Reafirmar la tarifa deseada (Flash por defecto o la elegida) si Releasit la cambió
    var desired = getDesiredRate(getForm());
    if (desired && desired.getAttribute('data-selected') !== 'true') scheduleApply();
  }, 500);

  installNetworkHooks();
  installSubmitHooks();
  hookModalBus();
  setInterval(hookModalBus, 1000);

  // Solo reaccionar a cambios relevantes (NO a cada has-content/completed del form)
  new MutationObserver(function (mutations) {
    if (hasBundleContext() || !isFormOpen()) return;
    if (isInteractionLocked() || state.applying) return;

    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (!t) continue;
      if (t.id === '_rsi-cod-form-modal' || t.id === 'rsi-cod-form-quantity-offers-hook') {
        relevant = true;
        break;
      }
      if (t.classList && (
        t.classList.contains('_rsi-quantity-offers-offer-container') ||
        t.classList.contains('_rsi-quantity-offers-selected') ||
        t.classList.contains('_rsi-cod-form-modal-open') ||
        t.classList.contains('_rsi-modal-shipping-rates-item')
      )) {
        relevant = true;
        break;
      }
    }
    if (!relevant) return;

    watchForm();
    if (enforceDesiredRateNow()) return;
    scheduleApply();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-selected'],
  });

  window._rsiSyncQoFreeShipping = function () {
    applyToForm();
  };
})();
